<ng-container *transloco="let t">
@for (task of tasks | filter: 'taskId'; track task.taskId) {
  <div class="d-flex align-items-stretch">
    <div class="card w-100 mb-4 p-2 border border-2 mobile-task-card" [class.mobile-expanded]="isTaskExpanded(task.taskId)">

      <!-- Mobile: compact accordion summary row (hidden on desktop) -->
      <div class="mobile-task-summary d-none" (click)="toggleTaskExpanded(task.taskId)">
        <div class="mobile-task-summary-left">
          <div class="mobile-task-title">{{ t('portal.tasks.homeownersInsuranceQuotes') }}</div>
          <div class="mobile-task-meta">
            @if (quotes?.length) {
              <span>{{ quotes.length }} {{ quotes.length !== 1 ? t('portal.tasks.quotePlural') : t('portal.tasks.quoteSingular') }}</span>
            } @else {
              <span>{{ t('portal.tasks.generatingQuotes') }}</span>
            }
          </div>
        </div>
        <div class="mobile-task-summary-right">
          @if (task.borrowerTaskStatus === 'Submitted') {
            <span class="badge rounded-pill bg-primary mobile-status-badge">{{ t('portal.tasks.submitted') }}</span>
          }
          @if (task.borrowerTaskStatus === 'Rejected') {
            <span class="badge rounded-pill bg-alert text-dark mobile-status-badge">{{ t('portal.tasks.rejected') }}</span>
          }
          @if (task.borrowerTaskStatus === 'Completed') {
            <span class="badge rounded-pill bg-success text-dark mobile-status-badge">{{ t('portal.tasks.completed') }}</span>
          }
          <i class="fas fa-chevron-down mobile-chevron" [class.rotated]="isTaskExpanded(task.taskId)"></i>
        </div>
      </div>

      <!-- Mobile: expandable content area (hidden until expanded) -->
      <div class="mobile-expand-content">
        @if (quotes?.length) {
          @for (quote of quotes; track quote.quoteID) {
            <div class="mobile-hoi-quote">
              <div class="mobile-hoi-quote-header">
                @if (quote?.logo) {
                  <img [src]="quote.logo" class="mobile-hoi-logo" alt="Logo">
                }
                <div class="mobile-hoi-carrier">
                  <span class="mobile-hoi-carrier-name">{{ quote.carrierName }}</span>
                  <span class="mobile-hoi-premium">{{ quote.premiumAmountAnnual }} / {{ t('portal.tasks.year') }}</span>
                </div>
              </div>
              <div class="mobile-hoi-actions">
                @if (!chosenQuoteId) {
                  <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color" (click)="chooseQuote(quote.quoteID)">
                    {{ t('portal.tasks.selectQuote') }}
                  </a>
                }
                @if (quote.quoteID == chosenQuoteId) {
                  <span class="badge bg-success">{{ t('portal.tasks.selected') }}</span>
                }
                <span class="badge badge-light-info">{{ t('portal.tasks.quoteId') }}: {{ quote.quoteID }}</span>
              </div>
            </div>
          }
        } @else {
          <div class="mobile-hoi-empty">
            {{ t('portal.tasks.quotesBeingGenerated') }}
          </div>
        }
      </div>

      <!-- Desktop: full card layout (hidden on mobile via CSS) -->
      <div class="desktop-task-content">
        <div class="card-header py-4 w-100 d-flex align-items-center justify-content-start border-bottom-2">
          <h4 class="w-100 mb-0 d-flex justify-content-between align-items-center">
            <span>{{ t('portal.tasks.yourHomeownersInsuranceQuotes') }}</span>

            <div>
              @if (task.borrowerFacingNote && task.borrowerTaskStatus === 'Rejected') {
                <span class="badge rounded-pill bg-warning text-dark p-3 m-1 task-status-badge">{{ t('portal.tasks.urgentMessage') }}</span>
              }
              @if (task.borrowerFacingNote && task.borrowerTaskStatus !== 'Rejected') {
                <span class="badge rounded-pill bg-light text-dark p-3 m-1 task-status-badge">{{ t('portal.tasks.newMessage') }}</span>
              }
              @if (task.linkedDocuments && task.linkedDocuments.length) {
                <span class="badge rounded-pill bg-light text-dark p-3 m-1 task-status-badge">{{ task.linkedDocuments.length }}
                  {{ t('portal.tasks.documents') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Pending') {
                <span class="badge rounded-pill bg-light text-dark p-3 m-1 task-status-badge">{{ t('portal.tasks.pending') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Submitted') {
                <span class="badge rounded-pill bg-light text-dark p-3 m-1 task-status-badge">{{ t('portal.tasks.submitted') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Rejected') {
                <span class="badge rounded-pill bg-warning text-dark p-3 m-1 task-status-badge">{{ t('portal.tasks.rejected') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Completed') {
                <span class="badge rounded-pill bg-light text-dark p-3 m-1 task-status-badge">{{ t('portal.tasks.completed') }}</span>
              }

            </div>
          </h4>
        </div>
        <div class="card-body">
          <div class="row my-2">
            @if (quotes?.length) {
              <div class="w-100 d-block">
                @for (quote of quotes; track quote.quoteID) {
                  <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
                    <div class="row">
                      <div class="col-auto ps-0">
                        <img [src]="quote?.logo" class="w-100px rounded" alt="Logo">
                      </div>

                      <div class="col">
                        <div class="text-gray-800 fw-bold">
                          {{ quote.carrierName}}
                        </div>
                        <div class="text-gray-400 fw-bold">{{ t('portal.tasks.premiumAmountAnnual') }}:
                          <span class="text-gray-900 fw-bold">
                            {{ quote.premiumAmountAnnual}}
                          </span>
                        </div>
                      </div>

                      <div class="col-auto">
                        <div class="text-center">
                          @if (!chosenQuoteId) {
                            <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body me-1"
                              [title]="t('portal.tasks.choose')" (click)="chooseQuote(quote.quoteID)">
                              <i class="bi bi-check2-square fs-6"></i>
                            </label>
                          }
                        </div>
                        <div>
                          @if (!chosenQuoteId || quote.quoteID != chosenQuoteId) {
                            <span class="badge badge-light-info">{{ t('portal.tasks.quoteId') }}:
                              {{quote.quoteID}}</span>
                          }
                          @if (quote.quoteID == chosenQuoteId) {
                            <span class="badge badge-light-info">{{ t('portal.tasks.chosenQuoteId') }}:
                              {{chosenQuoteId}}</span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            @if (!quotes?.length) {
              <div class="w-100 d-flex justify-content-center my-5">
                {{ t('portal.tasks.quotesBeingGenerated') }}
              </div>
            }

          </div>
        </div>
      </div>
    </div>
  </div>
}
</ng-container>
